export enum PushNotificationDeviceType {
  All = 'all',
  Mobile = 'mobile',
  Desktop = 'desktop',
}
